<template>
    <div class="autoCompleteWrapper">
        <input  type="text" :placeholder="placeholder" @focus="focusIN()" @blur="focusOUT()" @input="onChange($event)" :value="selectedValue"  class="form-control">
        <div v-if="resultsList && resultsList.length > 0" class="results">
            <ul>
                <li v-for="(item, key) of resultsList" :key="key" @click="onClick(item)">{{item.name}}</li>
            </ul>
        </div>
        <div v-if="minLength === true && resultsList && resultsList.length === 0"  class="results">
            <ul>
              <li>Please enter 3 or more characters </li>
            </ul>
        </div>
    </div>
</template>
<script>
import getDataofCountries from "../countries+states+cities.json";
import { debounce } from "lodash";

export default {
    name:"autoCompleteComponent",
    props:{
        placeholder:String,
        getValue:{ type: Function }
    },
    data() {
        return {
            countriesData: getDataofCountries,
            selectedValue:"",
            resultsList:[],
            minLength:false,
            debouncedSearch: debounce(this.searchData, 100), 
        };
     },
     mounted(){
      
     },
     watch: {
        "$store.state.activeObjectprops": {
            handler(updatedValues) {

                this.selectedValue = updatedValues?.city?.name;
            },
            deep: true,
            immediate: true

        },

        showForcast(value) {
            this.showForcastOnWeather(value)
        },
        transparentbg(value) {
            this.onTransparentBG(value)
        }
    },
    methods:{
        onClick(item){
            this.selectedValue = item.name;
            this.getValue(item);
            this.resultsList = [];
        },
        onChange(e){
            console.log(e.target.value)
            let value = e.target.value;
            this.selectedValue = value;
            this.debouncedSearch(value);
            // this.debouncedSearch(value);
    
        },
        focusIN(){
          this.minLength = true
        },

        focusOUT(){
          this.minLength = false
        },

        // Function to search data
        searchData(query) {
            query = query.toLowerCase(); // Convert the query to lowercase for case-insensitive search
  const results = [];


 // Set a minimum query length before starting the search
 const minQueryLength = 3; // You can adjust this value as needed

if (query.length < minQueryLength) {
  // Don't perform the search for queries shorter than the minimum length
  this.minLength = true;
  this.resultsList = [];
  return [];
} else {
  this.minLength = false;
}



  // Iterate through the main data
  for (const item of this.countriesData) {
    if (item.name.toLowerCase().includes(query)) {
      results.push({
        id: item.id,
        name: item.name,
        timezone:item.timezones &&  item.timezones[0]?.zoneName,
        latitude:item.latitude,
        longitude:item.longitude
      });
    } else {
      // Check the "cities" array
      const matchingCities = item.states.flatMap(state =>
        state.cities.filter(city => city.name.toLowerCase().includes(query))
      );

      for (const city of matchingCities) {
        const state = item.states.find(s => s.cities.includes(city));
        if (city.name.toLowerCase() === query) {
          results.push({
            id: city.id,
            name: city.name,
            timezone:item.timezones &&  item.timezones[0]?.zoneName,
            latitude:city.latitude,
            longitude:city.longitude
          });
        } else {
          results.push({
            id: city.id,
            name: `${city.name}, ${state.name}, ${item.name}`,
            timezone:item.timezones &&  item.timezones[0]?.zoneName,
            latitude:city.latitude,
            longitude:city.longitude
          });
        }
      }

      // Check the "states" array
      const matchingStates = item.states.filter(state => state.name.toLowerCase().includes(query));

      for (const state of matchingStates) {
        if (state.name.toLowerCase() === query) {
          results.push({
            id: state.id,
            name: state.name,
            timezone:  item.timezones &&  item.timezones[0]?.zoneName,
            latitude:state.latitude,
            longitude:state.longitude
          });
        } else {
          results.push({
            id: state.id,
            name: `${state.name}, ${item.name}`,
            timezone:item.timezones &&  item.timezones[0]?.zoneName,
            latitude:state.latitude,
            longitude:state.longitude
          });
        }
      }
    }
  }

  this.resultsList = query === "" ? [] :  results;
  return results;
        }
    }
}
</script>

<style scoped>
.autoCompleteWrapper{
    position: relative;
}
.results {
    border: 1px solid #ced4da;
    border-top: none !important;
    position: absolute;
    top: 38px;
    left: 0;
    right: 0;
    background: white;
    z-index: 99;
}
.results ul{
    padding: 0;
    margin: 0;
}
.results ul li{
    padding: 5px;
    margin: 0;
    list-style-type: none;
    cursor: pointer;
}
.results ul li:hover{
    background-color: #eee;
}

</style>